import NumericInput from './index.mjs';
import BaseComponent from '../Element/component.mjs';

/**
 * The NumericInput represents an input element that holds numbers.
 */
class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.elementClass = NumericInput;
    }
    render() {
        return super.render();
    }
}
Component.ctor = NumericInput;
var Component$1 = Component;

export { Component$1 as default };
